import { useLocalStorage } from "../../hooks/useLocalStorage";
import { Input } from '../ui/input2';

import { FormField } from "../../types/forms";

interface HeadingSectionProps {
  userId: string;
  templateId: string;
  fields?: FormField[];
}

export default function HeadingSection({ userId, templateId, fields }: HeadingSectionProps) {
  const storageKey = `${userId}_${templateId}_heading`;
  const [sectionHeading, setSectionHeading] = useLocalStorage<string>(storageKey, "");

  return (
    <div className="space-y-3">
      <h2 className="text-xl font-semibold text-gray-800">Heading</h2>

      <label className="block text-sm font-medium text-gray-700">Section Heading</label>
      <Input
        value={fields && fields.length > 0 ? (fields[0].options?.content || fields[0].label) : sectionHeading}
        onChange={(e) => !fields && setSectionHeading(e.target.value)}
        placeholder="Enter section heading..."
        readOnly={!!fields}
      />
    </div>
  );
}
